import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/site";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="bg-white py-24 md:py-32">
      <div className="pz-container">
        <div className="max-w-3xl">
          <span className="pz-overline">How we work</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]">
            A five-step process<br />engineered for clarity.
          </h2>
          <div className="pz-gold-line mt-6" />
          <p className="mt-6 text-slate-600 text-lg">
            From the first consultation to final delivery — every project moves through the same disciplined path.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* Timeline line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-[2px] bg-slate-100">
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: "easeInOut" }}
              style={{ transformOrigin: "left" }}
              className="h-full bg-gradient-to-r from-[#2563EB] via-[#2563EB] to-[#F59E0B]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {PROCESS_STEPS.map((s, i) => (
              <motion.div
                key={s.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                data-testid={`process-step-${s.step}`}
                className="relative"
              >
                {/* Dot */}
                <div className="hidden lg:flex relative z-10 w-12 h-12 rounded-full bg-white border-2 border-[#2563EB] items-center justify-center shadow-md">
                  <div className="w-3 h-3 rounded-full bg-[#F59E0B]" />
                </div>

                <div className="mt-6 lg:pr-6">
                  <div className="font-display text-5xl font-bold text-slate-200 leading-none">{s.step}</div>
                  <h3 className="mt-3 font-display text-xl font-semibold text-[#0F172A]">{s.title}</h3>
                  <p className="mt-3 text-slate-600 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
